// extracted by mini-css-extract-plugin
export default {"label":"ci2_label__4LQ9R","c":"ci2_c__q-D3y","trail":"ci2_trail__nbM6x"};